import React from "react";
import { useProfile } from "@/_actions/userActions";
import usePlanStore from "@/stores/planStore";
import apiClient from "@/utils/apiClient";
import { Loader2 } from "lucide-react";

export default function Subscription() {
  const plan = usePlanStore((state) => state.plan);
  const transaction = usePlanStore((state) => state.transaction);
  const [loading, setLoading] = React.useState(false);
  const { data: profile, isLoading, mutate: mutateProfile, error } = useProfile();

  const getStripeSessionUrl = async () => {
    setLoading(true);
    try {
      const session = await apiClient.post("/clients/create-customer-portal-session");
      const stripeSessionUrl = session?.data?.url;
      if (typeof stripeSessionUrl !== "string" || stripeSessionUrl.length === 0) {
        throw new Error("Customer portal session response missing url");
      }
      window.open(stripeSessionUrl, "_blank");
    } catch (err) {
      $log.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const stats = [
    { name: "Plan", stat: plan?.name },
    {
      name: "Propiedades disponibles para publicar",
      stat: `${
        plan?.plan_addons.properties_quantity == -1
          ? "Ilimitado"
          : plan?.plan_addons.properties_quantity
      }`,
    },
    {
      name: "Usuarios disponibles",
      stat: `${plan?.plan_addons.client_promoters}`,
    },
    profile?.contract_dates?.end_date
      ? {
          name: "Siguiente fecha de renovación",
          stat: `${profile?.contract_dates.end_date}`,
        }
      : {},
  ];

  return (
    <div>
      <div className="border-b border-zinc-300 pb-3 ">
        <div className="ml-12 border-l border-zinc-300 pl-4">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-zinc-800">
            Subscripción
          </h1>
        </div>
      </div>
      <div>
        <div className="container py-20 space-y-10 px-3">
          <div>
            <p className="text-xl text-gray-500  text-pretty font-regular">
              Administra tu suscripción a Casas y Terrenos PRO.<br></br> Puedes contratar y pausar
              tu suscripción en cualquier momento.
            </p>
          </div>

          <div className="space-y-5">
            <div className="relative">
              <div aria-hidden="true" className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-start">
                <span className="bg-white pr-3 text-base font-semibold text-gray-900">
                  Información sobre tu plan actual
                </span>
              </div>
            </div>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              {stats.map((item) => (
                <div
                  key={item.name}
                  className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-xs sm:p-6"
                >
                  <dt className="truncate text-sm font-medium text-gray-500 ">{item.name}</dt>
                  <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900 capitalize">
                    {item.stat}
                  </dd>
                </div>
              ))}
            </dl>

            {transaction?.payment_provider === "stripe" ? (
              <div>
                <button
                  disabled={loading}
                  onClick={getStripeSessionUrl}
                  type="button"
                  className="text-pretty flex rounded-md bg-gray-900 text-white px-3.5 py-2.5 text-sm
                hover:text-gray-900 shadow-2xs ring-1 ring-gray-300 ring-inset hover:bg-white
                disabled:bg-gray-300 disabled:text-gray-500"
                >
                  {loading ? <Loader2 className="animate-spin" /> : null}
                  <span>Administrar subscripción</span>
                </button>
              </div>
            ) : null}
          </div>
          <div className="space-y-5">
            {profile?.client && plan?.name === "starter" ? (
              <>
                <div className="relative">
                  <div aria-hidden="true" className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300" />
                  </div>
                  <div className="relative flex justify-start">
                    <span className="bg-white pr-3 text-base font-semibold text-gray-900">
                      Adquiere un plan
                    </span>
                  </div>
                </div>

                <div className="mt-5">
                  <p className="text-gray-500 max-w-[500px]  text-pretty font-regular">
                    Adquiere un plan de pago para poder publicar todo tu inventario y acceder a
                    todas las funcionalidades de Casas y Terrenos PRO.
                  </p>
                </div>
                <div>
                  <stripe-pricing-table
                    pricing-table-id={import.meta.env.VITE_STRIPE_PRICING_TABLE_ID}
                    publishable-key={import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY}
                    client-reference-id={profile?.client}
                    customer-email={profile?.email}
                  ></stripe-pricing-table>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
